import { useEffect, useState } from "react"

const getMatch = (query) => {
  if (typeof window === "undefined") return false
  return window.matchMedia(query).matches
}

const useIsMobile = (query = "(max-width: 767px)") => {
  const [isMobile, setIsMobile] = useState(() => getMatch(query))

  useEffect(() => {
    const mq = window.matchMedia(query)
    const onChange = () => setIsMobile(mq.matches)

    onChange()

    // addEventListener 지원 안하는 브라우저도 커버
    mq.addEventListener("change", onChange)

    return () => {
      mq.removeEventListener("change", onChange)
    }
  }, [query])

  return isMobile
}

export default useIsMobile
